import type {
  Filters,
  IntentRule,
  OasDocument3XExtended,
} from '@ipfabric/utils';
import type {
  DeviceViewEdgeEntity,
  DeviceViewNodeEntity,
} from 'components/DeviceView/deviceViewTypes';
import { getEdgeFilters } from './getEdgeFilters';
import { getNodeFilters } from './getNodeFilters';

const validateEntityData = (
  deviceViewEntity: DeviceViewNodeEntity | DeviceViewEdgeEntity,
): boolean => {
  if (deviceViewEntity.deviceViewElement === 'node') {
    return !!deviceViewEntity.sn;
  }
  return !!deviceViewEntity.edges && deviceViewEntity.edges.length > 0;
};

export const getFilters = (
  apiEndpoint: string,
  deviceViewEntity: DeviceViewNodeEntity | DeviceViewEdgeEntity,
  selectedTable: string,
  intentRule: IntentRule | null,
  oas: OasDocument3XExtended,
): Filters | undefined => {
  if (!validateEntityData(deviceViewEntity)) {
    return undefined;
  }
  return deviceViewEntity.deviceViewElement === 'node'
    ? getNodeFilters(deviceViewEntity, apiEndpoint, oas)
    : getEdgeFilters(deviceViewEntity, selectedTable, intentRule);
};
